import React, { Component } from 'react';

interface IProps {
    gtmEvent(): void;
    name: string;
    mortgageAmount: number;
}

export class Terminator extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Thanks, {this.props.name}</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                    <h1 className='l'>We're now looking at all options to<br/> source the best mortgage for you.</h1>
                    </div>
                    <div className='row'>
                        {this.props.mortgageAmount >= 180000 &&
                        <p className='s'>Your dedicated mortgage specialist will call you in the next 24hrs to<br/>review options and to answer any additional questions you might have.</p>
                        }
                    </div>
                    <div className='row pt-2'>
                        <div className='btn-primary' onClick={() => window.location.href='/'}>Close</div>
                    </div>
                </div>
            </header>
        );
    }
}
